module.exports = __webpack_public_path__ + "img/LogoKurierConsult.d06148eb.png";